import React from 'react';
import { Link } from 'react-router-dom';
import LineSeperator from '../ui/LineSeperator';
import '../../stylings/Message.css';

export default function Message() {
  return (
    <section className="message-section">
      <div className="container-fluid px-5">
        <LineSeperator title="Messages from Leadership" />
        <div className="row g-4 mt-2">
          <div className="col-lg-4 col-md-6">
            <MessageCard
              role="Principal"
              name="Geeta Rani"
              quote="Education is not the filling of a pail, but the lighting of a fire. At Akash Model School, we ignite that spark in every child."
              link="/principal-message"
            />
          </div>
          <div className="col-lg-4 col-md-6">
            <MessageCard
              role="Chairman"
              name="Sanjjev Sir"
              quote="Our vision is to create responsible citizens who contribute positively to society. We are committed to excellence in education and character building."
              link="/chairman-message"
            />
          </div>
          <div className="col-lg-4 col-md-6">
            <MessageCard
              role="Manager"
              name="School Management"
              quote="We believe every student has unique potential. Our dedicated team works tirelessly to provide the best learning environment for all our students."
              link="/manager-message"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function MessageCard({ role, name, quote, link }) {
  return (
    <div className="message-card">
      <div className="message-icon">
        <i className="fas fa-user-tie"></i>
      </div>
      <div className="message-role-badge">{role}</div>
      <blockquote className="message-quote">"{quote}"</blockquote>
      <div className="message-author">
        <strong>{name}</strong>
        <span>{role}, Akash Model School</span>
      </div>
      <Link to={link} className="message-read-more">Read Full Message →</Link>
    </div>
  );
}
